<template>
  <div class="container mt-4" dir="rtl">

    <!-- العنوان الرئيسي -->
    <div class="d-flex justify-content-between align-items-center mb-4 bg-white p-3 rounded shadow-sm border-start border-5 border-primary">
      <div>
        <h4 class="fw-bold text-primary mb-1">
          <i class="fas fa-cogs ms-2"></i> العمليات الآلية وإعداد البيانات
        </h4>
        <p class="text-muted small mb-0">توزيع أرقام الجلوس - مزامنة المدارس - تسكين حالات الدمج</p>
      </div>
    </div>

    <div class="row">
      
      <!-- 1. القائمة الجانبية -->
      <div class="col-md-3 mb-4">
        <div class="list-group shadow-sm">
          
          <button @click="activeTab = 'seating'" class="list-group-item list-group-item-action py-3 fw-bold d-flex justify-content-between align-items-center" :class="{ active: activeTab === 'seating' }">
            <span><i class="fas fa-sort-numeric-down ms-2"></i> توزيع أرقام الجلوس</span>
            <i class="fas fa-chevron-left small"></i>
          </button>
          
          <button @click="activeTab = 'sync'" class="list-group-item list-group-item-action py-3 fw-bold d-flex justify-content-between align-items-center" :class="{ active: activeTab === 'sync' }">
            <span><i class="fas fa-sync-alt ms-2"></i> مزامنة بيانات المدارس</span>
            <i class="fas fa-chevron-left small"></i>
          </button>

          <button @click="activeTab = 'damg'" class="list-group-item list-group-item-action py-3 fw-bold d-flex justify-content-between align-items-center" :class="{ active: activeTab === 'damg' }">
            <span><i class="fas fa-wheelchair ms-2"></i> تسكين حالات الدمج</span>
            <i class="fas fa-chevron-left small"></i>
          </button>

        </div>
      </div>

      <!-- 2. المحتوى -->
      <div class="col-md-9">
        
        <!-- ======================================================= -->
        <!-- Tab 1: توزيع أرقام الجلوس -->
        <!-- ======================================================= -->
        <div v-if="activeTab === 'seating'" class="card shadow-sm border-0 animate__animated animate__fadeIn">
          <div class="card-header bg-dark text-white py-3">
            <h5 class="m-0 fw-bold"><i class="fas fa-list-ol ms-2"></i> إعدادات الترقيم الآلي</h5>
          </div>
          <div class="card-body p-4">
            
            <!-- تنبيه هام (تمت استعادته) -->
            <div class="alert alert-warning border-warning d-flex align-items-start mb-4 shadow-sm">
                <i class="fas fa-exclamation-triangle fa-2x ms-3 text-warning mt-1"></i>
                <div>
                    <strong>تنبيه هام جداً:</strong><br>
                    1. هذه العملية ستقوم بمسح أرقام الجلوس الحالية للفئة المختارة.<br>
                    2. سيتم إعادة ترتيب الطلاب (إدارة > مدرسة > اسم) وتوزيع أرقام جديدة.<br>
                    3. يرجى التأكد من اختيار "مكان الحفظ" الصحيح (الفصل الدراسي).
                </div>
            </div>

            <form @submit.prevent="confirmGeneration">
                <div class="row g-4">
                    <div class="col-md-12">
                        <label class="form-label fw-bold">مكان الحفظ (العمود المستهدف)</label>
                        <select v-model="seatingForm.target_col" class="form-select form-select-lg border-primary" required>
                            <option value="Seating_No_1">الفصل الدراسي الأول (Seating_No_1)</option>
                            <option value="Seating_No_2">الفصل الدراسي الثاني (Seating_No_2)</option>
                            <option value="Seating_No_R2">الدور الثاني (Seating_No_R2)</option>
                        </select>
                    </div>

                    <div class="col-md-6">
                        <label class="form-label fw-bold">فئة الطلاب</label>
                        <div class="d-flex flex-column gap-2">
                            <label class="btn btn-outline-success d-flex align-items-center justify-content-between p-2 px-3" :class="{active: seatingForm.student_type === 1}">
                                <span><i class="fas fa-user-graduate ms-2"></i> طلاب نظامي</span>
                                <input type="radio" v-model="seatingForm.student_type" :value="1" class="form-check-input"> 
                            </label>
                            <label class="btn btn-outline-secondary d-flex align-items-center justify-content-between p-2 px-3" :class="{active: seatingForm.student_type === 2}">
                                <span><i class="fas fa-home ms-2"></i> طلاب منازل</span>
                                <input type="radio" v-model="seatingForm.student_type" :value="2" class="form-check-input"> 
                            </label>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <label class="form-label fw-bold">بداية رقم الجلوس</label>
                        <input type="number" v-model.number="seatingForm.start_number" class="form-control form-control-lg text-center fw-bold font-monospace" placeholder="مثال: 1001" required>
                        <div class="form-text">الرقم الذي سيبدأ به أول طالب في الكشف.</div>
                    </div>
                </div>

                <div class="text-center mt-4 border-top pt-3">
                    <button type="submit" class="btn btn-primary px-5 fw-bold shadow hover-effect" :disabled="loading">
                        <span v-if="loading" class="spinner-border spinner-border-sm ms-2"></span>
                        <i class="fas fa-play ms-2"></i> بدء التوزيع والحفظ
                    </button>
                </div>
            </form>

            <div v-if="seatingResult" class="alert alert-success mt-4 text-center border-success">
                <h5 class="fw-bold"><i class="fas fa-check-circle"></i> {{ seatingResult.message }}</h5>
                <hr>
                <div class="d-flex justify-content-center gap-4 fw-bold fs-5">
                    <span class="badge bg-white text-success border border-success px-3">من: {{ seatingResult.start_number }}</span>
                    <i class="fas fa-arrow-left text-muted align-self-center"></i>
                    <span class="badge bg-white text-success border border-success px-3">إلى: {{ seatingResult.last_number }}</span>
                </div>
            </div>

          </div>
        </div>

        <!-- ======================================================= -->
        <!-- Tab 2: مزامنة البيانات -->
        <!-- ======================================================= -->
        <div v-if="activeTab === 'sync'" class="card shadow-sm border-0 animate__animated animate__fadeIn">
          <div class="card-header bg-primary text-white py-3">
            <h5 class="m-0 fw-bold"><i class="fas fa-database ms-2"></i> مزامنة بيانات المدارس</h5>
          </div>
          <div class="card-body p-4 text-center">
            
            <div class="mb-4">
                <i class="fas fa-sync-alt fa-4x text-primary mb-3 opacity-50" :class="{'fa-spin': loading}"></i>
                <h5 class="fw-bold">تحديث أرقام اللجان والإدارات للطلاب</h5>
            </div>

            <!-- تعليمات المزامنة (تمت استعادتها) -->
            <div class="alert alert-info border-info text-start px-4 shadow-sm mb-4">
                <h6 class="fw-bold"><i class="fas fa-info-circle ms-2"></i> كيفية عمل المزامنة:</h6>
                <ul class="mb-0 small text-dark" style="line-height: 1.8;">
                    <li>يقوم النظام بالبحث عن الطلاب باستخدام <strong>كود المدرسة (School Code)</strong>.</li>
                    <li>يتم جلب (رقم اللجنة - ورقم الإدارة) من جدول المدارس وتحديث بيانات الطالب بها.</li>
                    <li>يجب التأكد أولاً من صحة بيانات "جدول المدارس" قبل تشغيل هذه العملية.</li>
                </ul>
            </div>

            <button @click="startSync" class="btn btn-lg btn-success px-5 fw-bold shadow-sm" :disabled="loading">
                <span v-if="loading" class="spinner-border spinner-border-sm ms-2"></span>
                <span v-else><i class="fas fa-play ms-2"></i> تنفيذ المزامنة الآن</span>
            </button>

            <div v-if="syncResult" class="mt-4 alert alert-success animate__animated animate__fadeInUp">
                <i class="fas fa-check-double ms-2"></i> تمت العملية بنجاح! تم تحديث بيانات <strong>{{ syncResult.updated_count }}</strong> طالب.
            </div>
          </div>
        </div>

        <!-- ======================================================= -->
        <!-- Tab 3: تسكين الدمج (مع التعديلات المطلوبة) -->
        <!-- ======================================================= -->
        <div v-if="activeTab === 'damg'" class="card shadow-sm border-0 animate__animated animate__fadeIn">
          <div class="card-header bg-warning text-dark py-3 d-flex justify-content-between align-items-center">
            <h5 class="m-0 fw-bold"><i class="fas fa-wheelchair ms-2"></i> تسكين أنواع الإعاقة (طلاب الدمج)</h5>
          </div>

          <div class="card-body p-0">
            
            <!-- تعليمات الدمج -->
            <div class="alert alert-light border-bottom mb-0 rounded-0 px-4 py-3">
                <div class="row align-items-center">
                    <div class="col-md-8">
                        <strong class="text-dark"><i class="fas fa-lightbulb text-warning ms-2"></i> تعليمات:</strong>
                        <span class="text-muted small">
                            تظهر هنا قائمة بجميع الطلاب المسجلين كـ "دمج". قم باختيار نوع الإعاقة من القائمة وسيتم الحفظ تلقائياً.
                        </span>
                    </div>
                    <div class="col-md-4">
                        <!-- بحث سريع -->
                        <div class="input-group input-group-sm">
                            <span class="input-group-text bg-white"><i class="fas fa-search"></i></span>
                            <input v-model="damgSearch" @input="debouncedDamgFetch" type="text" class="form-control" placeholder="بحث بالاسم أو الجلوس...">
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-responsive">
                <table class="table table-hover align-middle text-center mb-0">
                    <thead class="bg-light text-dark">
                        <tr>
                            <th width="15%">رقم الجلوس</th>
                            <th width="35%">اسم الطالب</th>
                            <th width="35%">تحديد نوع الإعاقة</th>
                            <th width="15%">حالة الحفظ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="student in damgStudents.data" :key="student.id" :class="{'table-success': student.saved}">
                            <td class="fw-bold font-monospace fs-5">{{ student.Seating_No }}</td>
                            <td class="text-start fw-bold text-primary">{{ student.Arabic_Name }}</td>
                            
                            <!-- القائمة المنسدلة -->
                            <td>
                                <div class="position-relative">
                                    <select 
                                        v-model="student.damge_id" 
                                        @change="saveDamgChange(student)" 
                                        class="form-select border-2 fw-bold"
                                        :class="student.damge_id ? 'border-primary text-primary' : 'border-secondary text-muted'"
                                    >
                                        <option :value="null">-- اختر نوع الإعاقة --</option>
                                        <option v-for="type in damgTypes" :key="type.id" :value="type.id">
                                            {{ type.name }}
                                        </option>
                                    </select>
                                    <!-- لودينج صغير -->
                                    <div v-if="student.loading" class="position-absolute top-50 start-0 translate-middle-y ms-2">
                                        <span class="spinner-border spinner-border-sm text-secondary"></span>
                                    </div>
                                </div>
                            </td>

                            <!-- حالة الحفظ -->
                            <td>
                                <span v-if="student.saved" class="text-success fw-bold fade-in">
                                    <i class="fas fa-check-circle"></i> تم الحفظ
                                </span>
                                <span v-else class="text-muted small">
                                    {{ student.disability_type || 'بانتظار التحديد' }}
                                </span>
                            </td>
                        </tr>
                        
                        <!-- رسالة في حال عدم وجود طلاب دمج -->
                        <tr v-if="!loading && (!damgStudents.data || damgStudents.data.length === 0)">
                            <td colspan="4" class="py-5 text-muted">
                                <i class="fas fa-info-circle fa-2x mb-2 d-block opacity-25"></i>
                                لا يوجد طلاب دمج مسجلين، أو لا توجد نتائج للبحث.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Pagination للدمج -->
            <div class="card-footer bg-white py-3 d-flex justify-content-center" v-if="damgStudents.last_page > 1">
                <nav>
                    <ul class="pagination pagination-sm mb-0">
                        <li class="page-item" :class="{disabled: !damgStudents.prev_page_url}">
                            <button class="page-link" @click="fetchDamgData(damgStudents.current_page - 1)">السابق</button>
                        </li>
                        <li class="page-item active"><span class="page-link">{{ damgStudents.current_page }}</span></li>
                        <li class="page-item" :class="{disabled: !damgStudents.next_page_url}">
                            <button class="page-link" @click="fetchDamgData(damgStudents.current_page + 1)">التالي</button>
                        </li>
                    </ul>
                </nav>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/axios';
import Swal from 'sweetalert2';
import _ from 'lodash';

export default {
  name: "SeatingDistribution",
  data() {
    return {
      activeTab: 'seating',
      loading: false,

      // 1. بيانات أرقام الجلوس
      seatingForm: { target_col: 'Seating_No_1', student_type: 1, start_number: '' },
      seatingResult: null,

      // 2. بيانات المزامنة
      syncResult: null,

      // 3. بيانات الدمج
      damgSearch: '',
      damgTypes: [],
      damgStudents: {}, // كائن يحتوي على data (array) و links و meta للباجينيشن
    };
  },
  
  // المراقب: عند فتح تبويب الدمج، نجلب البيانات فوراً
  watch: {
    activeTab(val) {
        if(val === 'damg') {
            // نجلب البيانات دائماً عند الفتح للتأكد من التحديث
            // إذا كنت تريد جلبها مرة واحدة فقط، أضف شرط: && this.damgTypes.length === 0
            this.fetchDamgData();
        }
    }
  },

  methods: {
    // --- (1) دوال أرقام الجلوس ---
    async confirmGeneration() {
        if (!this.seatingForm.start_number) return Swal.fire('تنبيه', 'أدخل رقم البداية', 'warning');
        const confirm = await Swal.fire({
            title: 'تأكيد التوزيع',
            html: "سيتم تغيير أرقام الجلوس الحالية واستبدالها.<br><b>هل أنت متأكد؟</b>",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'نعم، ابدأ',
            cancelButtonText: 'إلغاء'
        });
        if (confirm.isConfirmed) this.generateNumbers();
    },
    async generateNumbers() {
        this.loading = true;
        this.seatingResult = null;
        try {
            const res = await api.post('/control/generate-seating', this.seatingForm);
            this.seatingResult = res.data;
            Swal.fire('تم', 'تم التوزيع بنجاح', 'success');
        } catch (error) { Swal.fire('خطأ', 'فشلت العملية', 'error'); } 
        finally { this.loading = false; }
    },

    // --- (2) دوال المزامنة ---
    async startSync() {
        const confirm = await Swal.fire({
            title: 'تأكيد المزامنة',
            text: "هل تريد تحديث بيانات الطلاب بناءً على أكواد المدارس؟",
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'نعم',
            cancelButtonText: 'لا'
        });

        if (!confirm.isConfirmed) return;

        this.loading = true;
        try {
            const res = await api.post('/control/sync-by-code');
            this.syncResult = res.data;
            Swal.fire('نجاح', `تم تحديث ${res.data.updated_count} طالب`, 'success');
        } catch (error) { Swal.fire('خطأ', 'فشل الاتصال', 'error'); } 
        finally { this.loading = false; }
    },

    // --- (3) دوال الدمج (المعدلة) ---
    async fetchDamgData(page = 1) {
        // لا نفعل loading كامل للصفحة لكي لا يختفي التبويب، يمكن استخدامه داخل الجدول
        try {
            const res = await api.get('/control/damg-data', {
                params: { page, search: this.damgSearch }
            });
            
            this.damgTypes = res.data.damg_types;
            
            // معالجة البيانات لإضافة خصائص الواجهة
            const studentsData = res.data.students;
            if (studentsData.data) {
                studentsData.data = studentsData.data.map(s => ({
                    ...s, 
                    loading: false, 
                    saved: false 
                }));
            }
            this.damgStudents = studentsData;
        } catch (e) { 
            console.error(e); 
        }
    },

    debouncedDamgFetch: _.debounce(function() {
        this.fetchDamgData(1);
    }, 500),

    async saveDamgChange(student) {
        this.$set(student, 'loading', true);
        this.$set(student, 'saved', false);
        
        try {
            const res = await api.post('/control/update-damg', {
                student_id: student.id,
                damge_id: student.damge_id
            });
            
            student.disability_type = res.data.type_name;
            this.$set(student, 'saved', true);
            setTimeout(() => { this.$set(student, 'saved', false); }, 2000);
        } catch (e) {
            Swal.fire('خطأ', 'فشل الحفظ', 'error');
        } finally {
            this.$set(student, 'loading', false);
        }
    }
  }
};
</script>

<style scoped>
.font-monospace { font-family: 'Courier New', Courier, monospace; letter-spacing: 1px; }
.hover-effect:hover { transform: translateY(-2px); }
.fade-in { animation: fadeIn 0.5s; }
@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }

/* أزرار القائمة الجانبية */
.list-group-item.active {
    background-color: #0d6efd;
    border-color: #0d6efd;
}
</style>